import { GzEasmOpenPortsWebComponent } from './component/GzEasmOpenPortsWebComponent';

export { GzEasmOpenPortsWebComponent };
